import React, { Component } from 'react'
import Button from '../Commons/Button'

import './Vagas.scss'

class Vagas extends Component {
  render() {
    return (
      <section className="vagas-section" style={{marginBottom: '100px'}}>

        <div className="container" style={{backgroundColor: '#fff', borderRadius: '0.5rem', marginBottom: '60px'}}>
          <div>
            <div className="grid-1-noGutter">
              <div className="col">
                <img src={require('../../sass/images/vagas-bg.png')} alt="" style={{width: '100%'}}/>
              </div>
            </div>
          </div>

          <div className="padding">
            <div className="grid-1">
              <div className="col feature">
                <h3>Nossa equipe estende o alcance e a importância das direções preferenciais no sentido do progresso. A competitividade nas transações comerciais possibilita uma melhor visão global do processo de comunicação como um todo.</h3>
              </div>
            </div>
            <div className="grid-noGutter-equalHeight-center box-list">
              <div className="col-4_xs-12 box auto">
                <div>
                  <h6>Espaço criativo</h6>
                  <p>A certificação de metodologias que nos auxiliam a lidar com a valorização de fatores subjetivos nos obriga à análise das condições financeiras e administrativas.</p>
                </div>
              </div>

              <div className="col-4_xs-12 box auto">
                <div>
                  <h6>Produto inovador</h6>
                  <p>O entendimento das metas propostas maximiza as possibilidades por conta dos conhecimentos estratégicos para atingir a excelência desejada pelo mercado.</p>
                </div>
              </div>

              <div className="col-4_xs-12 box auto">
                <div>
                  <h6>Trabalho remoto</h6>
                  <p>O empenho em analisar o comprometimento entre as equipes prepara-nos para enfrentar situações atípicas de motivação departamental.</p>
                </div>
              </div>

              <div className="col-4_xs-12 box auto">
                <div>
                  <h6>Startup em expansão</h6>
                  <p>A nível organizacional, o novo modelo estrutural aqui preconizado oferece uma interessante oportunidade para verificação dos índices pretendidos. </p>
                </div>
              </div>

              <div className="col-4_xs-12 box auto">
                <div>
                  <h6>Colaboração mútua</h6>
                  <p>A nível organizacional, o novo modelo estrutural aqui preconizado oferece uma interessante oportunidade para verificação dos índices pretendidos. </p>
                </div>
              </div>

              <div className="col-4_xs-12 box auto">
                <div>
                  <h6>Equipe experiente</h6>
                  <p>O empenho em analisar o comprometimento entre as equipes prepara-nos para enfrentar situações atípicas de motivação departamental.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container padding" style={{backgroundColor: '#fff', borderRadius: '0.5rem'}}>
          <div className="grid-1">
            <div className="col text-center" style={{marginBottom: '100px'}}>
              <span className="heading-tag"></span>
              <h2 className="title">Lista de vagas</h2>
            </div>
            <div className="grid-2-spaceBetween vaga">
              <div className="col">
                <h4>Senior Platform Engineer</h4>
                <p>O incentivo ao avanço tecnológico, assim como a hegemonia do ambiente político maximiza as possibilidades por conta das diversas correntes de pensamento.</p>
              </div>
              <div className="col-2">
                <Button name="green transparent" text="Candidatar" />
              </div>
            </div>
          </div>
        </div>

        <div className="container padding" style={{backgroundColor: '#fff', borderRadius: '0.5rem'}}>
          <div className="grid-1">
            <div className="col text-center">
              <span className="heading-tag"></span>
              <h2 className="title">Banco de Talentos</h2>
            </div>
            <div className="grid-1" style={{marginBottom: '100px'}}>
              <div className="col feature">
                <h3>Não encontrou nenhuma vaga? Não se preocupe! Cadastre o seu currículo e nós avisaremos quando surgir uma oportunidade.</h3>
              </div>
            </div>
            <div className="grid-center form">
              <div className="col-6" data-push-left="off-1">
                <label htmlFor="name">Nome</label>
                <input type="type_text" name="name" id="name" />
                <span className="error alert"></span>
              </div>
              <div className="col-6" data-push-left="off-1">
                <label htmlFor="email">Email</label>
                <input type="type_text" name="email" id="email" />
                <span className="error alert"></span>
              </div>
              <div className="col-6" data-push-left="off-1">
                <div className="control-group">
                    <label className="control control-checkbox">
                        Desejo receber novidades por email
                            <input type="checkbox" />
                        <div className="control_indicator"></div>
                    </label>
                </div>
              </div>
              <div className="col-6 upload-container" data-push-left="off-1" style={{borderTop: '1px solid #dce7eb', borderBottom: '1px solid #dce7eb', padding: '25px 0'}}>
                <div className="file-upload">
                    <label for="upload" className="file-upload__label">+</label>
                    <input id="upload" className="file-upload__input" type="file" name="file-upload" />
                </div>
                <div>
                  <p><span>Adicionar currículo</span>
                  (arquivo em pdf, doc, docx)</p>
                </div>
              </div>
            </div>
            <div className="col grid-center" style={{paddingTop: '30px'}}>
              <div className="col text-center">
                <Button name="submit" id="submit" type="button" text="Enviar" />
              </div>
            </div>
          </div>
        </div>

      </section>
    );
  }
}

export default Vagas;



// WEBPACK FOOTER //
// ./src/components/Vagas/index.js